var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.cbf972938cdbaa87321a007fb479196c.svg#k';
                    var viewUrl = 'sprites.cbf972938cdbaa87321a007fb479196c.svg#view-k';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 112 75',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };